import React, { Fragment } from 'react'

import DashboardIcon from 'custom/assets/common-icons/dashboard.svg'

import Dash_PaymentsIcon from 'custom/assets/dashboard/payments.svg'
import Dash_PortfolioIcon from 'custom/assets/dashboard/portfolio.svg'
import Dash_LoanIcon from 'custom/assets/dashboard/loan.svg'
import Dash_DepositIcon from 'custom/assets/dashboard/deposit.svg'
import Dash_RequestIcon from 'custom/assets/dashboard/Request.svg'
import Dash_DownloadCenterIcon from 'custom/assets/dashboard/Download_center.svg'
import Dash_Support_CenterIcon from 'custom/assets/dashboard/Support_Center.svg'
import Dash_TransfersIcon from 'custom/assets/dashboard/transfers.svg'
import Dash_AccountsIcon from 'custom/assets/dashboard/Accounts.svg'
import Dash_ApprovalIcon from 'custom/assets/dashboard/Approval.svg'
import Dash_HistoryIcon from 'custom/assets/dashboard/History.svg'
import OtherServicesIcon from 'custom/assets/dashboard/OtherServices.svg'
import Other_DownloadCenterIcon from 'custom/assets/common-icons/DownloadCenter.svg'
import Other_SupportCenterIcon from 'custom/assets/common-icons/SupportCenter.svg'
import Desc_Contact_UsIcon from 'custom/assets/art-icons/Contact_Us.svg'

import Side_DashboardIcon from 'custom/assets/side-bar/Dashboard_Sidebar.svg'
import Side_DepositIcon from 'custom/assets/side-bar/Deposits.svg'
import Side_DownloadCenterIcon from 'custom/assets/side-bar/DownloadCenter.svg'
import Side_LoansIcon from 'custom/assets/side-bar/Loans.svg'
import Side_PaymentsIcon from 'custom/assets/side-bar/Payments.svg'
import Side_SupportCenterIcon from 'custom/assets/side-bar/SupportCenter.svg'
import Side_TransfersIcon from 'custom/assets/side-bar/Transfers.svg'
import Side_PortfolioIcon from 'custom/assets/side-bar/Portfolio.svg'
import Side_QuickLinksIcon from 'custom/assets/side-bar/QuickLinks.svg'
import Side_AccountsIcon from 'custom/assets/side-bar/Accounts_menu.svg'
import Side_RequestIcon from 'custom/assets/side-bar/Request.svg'
import Side_Approval from 'custom/assets/side-bar/Approval.svg'
import Side_History from 'custom/assets/side-bar/History.svg'
import Side_OtherServices from 'custom/assets/side-bar/OtherServices.svg'

import Account_RequestIcon from 'custom/assets/accounts/Request.svg'
import Account_Beneficiary_TransferIcon from 'custom/assets/accounts/Beneficiary_Transfer.svg'
import Account_DelinkIcon from 'custom/assets/accounts/Delink.svg'
import Account_LinkIcon from 'custom/assets/accounts/Link.svg'
import Account_PaymentIcon from 'custom/assets/accounts/Payment.svg'
import Account_Quick_TransferIcon from 'custom/assets/accounts/Quick_Transfer.svg'
import Account_Set_account_nameIcon from 'custom/assets/accounts/Set_account_name.svg'
import Account_StatementIcon from 'custom/assets/accounts/Statement.svg'

import Desc_LinkAccountIcon from 'custom/assets/art-icons/LinkAccount.svg'
import Desc_DeLinkAccountIcon from 'custom/assets/art-icons/DeLink.svg'
import Desc_SupportIcon from 'custom/assets/art-icons/support.svg'
import Desc_AdditionalIcon from 'custom/assets/art-icons/additional_option.svg'
import Desc_DownloadIcon from 'custom/assets/art-icons/download_center.svg'
import Desc_FAQIcon from 'custom/assets/art-icons/FAQ.svg'
import Desc_SuggestionsIcon from 'custom/assets/art-icons/suggestions.svg'
import Desc_CalculatorIcon from 'custom/assets/art-icons/Calculator.svg'
import Desc_ExchangeRatesIcon from 'custom/assets/art-icons/Exchange_rate.svg'
import Desc_DepositIcon from 'custom/assets/art-icons/Deposites.svg'
import Desc_BranchIcon from 'custom/assets/art-icons/Location.svg'
import Desc_LoanIcon from 'custom/assets/art-icons/Loan.svg'
import Desc_depositeIcon from 'custom/assets/art-icons/Deposites.svg'
import Desc_Mt103 from 'custom/assets/art-icons/MT103.svg'
import Desc_DebitCardIcon from 'custom/assets/art-icons/DebitCard.svg'

import Transfers_AddIcon from 'custom/assets/transfers/Add.svg'
import Transfers_ViewBeneficiariesIcon from 'custom/assets/transfers/View_Beneficiary.svg'
import Transfers_MakeTransferIcon from 'custom/assets/transfers/Beneficary_Transfer.svg'
import Transfers_DownloadIcon from 'custom/assets/transfers/Download.svg'

import Transfers_Salary_UploadIcon from 'custom/assets/transfers/Salary_upload.svg'
import Transfers_BulTransferIcon from 'custom/assets/transfers/Bulk_transfer.svg'
import Transfers_QuickTransferIcon from 'custom/assets/transfers/QuickTransfer.svg'
import Transfers_InternalIcon from 'custom/assets/transfers/Internal_Beneficiary.svg'
import Transfers_ViewScheduledIcon from 'custom/assets/transfers/View_Scheduled.svg'
import Transfers_InternationalIcon from 'custom/assets/transfers/International_Beneficiary.svg'
import Transfers_DomesticIcon from 'custom/assets/transfers/Domestic_Beneficiary.svg'
import Transfers_RegionalIcon from 'custom/assets/transfers/Regional_Beneficiary.svg'
import QuickTransfer_InstantTransferIcon from 'custom/assets/quickTransfer/InstantTransfer.svg'

import D_BIIcon from 'custom/assets/quick-links/Bi_Statement.svg'
import D_MTIcon from 'custom/assets/quick-links/MT103.svg'
import D_ReceiptsIcon from 'custom/assets/quick-links/Receipts.svg'

import S_BranchIcon from 'custom/assets/quick-links/branch.svg'
import S_AboutIcon from 'custom/assets/quick-links/AboutUs.svg'
import S_ContactIcon from 'custom/assets/quick-links/contactUs.svg'
import S_FAQIcon from 'custom/assets/quick-links/faq.svg'
import S_SuggestionIcon from 'custom/assets/quick-links/suggestion.svg'

import Q_CalculatorIcon from 'custom/assets/quick-links/Calculator.svg'
import Q_ExchangeIcon from 'custom/assets/quick-links/exchange.svg'
import Q_TCIcon from 'custom/assets/quick-links/Terms_Conditions.svg'

import R_ChequeBookIcon from 'custom/assets/cheque/Cheque_Book_Request.svg'
import R_ChequeStopIcon from 'custom/assets/cheque/Stop_Cheque_Payment.svg'
import R_ChequeStatusIcon from 'custom/assets/cheque/Cheque_Status.svg'

import R_ChequeIcon from 'custom/assets/cheque/Cheque.svg'
import R_SIIcon from 'custom/assets/cheque/Standing_Instruction.svg'
import R_Cheque_Status_Icon from 'custom/assets/cheque/Cheque_Status.svg'
import R_Debit_card from 'custom/assets/debit-card/ReissueCard.svg'
import Request_Debit_card from 'custom/assets/debit-card/RequestCard.svg'
import Block_Debit_card from 'custom/assets/debit-card/BlockCard.svg'

import P_ViewBillerIcon from 'custom/assets/payments/ViewBiller.svg'
import P_ServicesIcon from 'custom/assets/payments/Services.svg'
import P_AirtimeIcon from 'custom/assets/payments/Airtime.svg'
import P_BuyDataIcon from 'custom/assets/payments/Buy_Data.svg'
import P_SchoolPaymentIcon from 'custom/assets/payments/School_Payments.svg'
import P_OtherPaymentIcon from 'custom/assets/payments/Other_Payments.svg'
import P_AddBillerIcon from 'custom/assets/payments/Add_Biller_Beneficiary.svg'
import P_ViewScheduledIcon from 'custom/assets/payments/View_Scheduled_Payments.svg'
import { ADD_BENEFICIARY_KEYS, OTHER_SRVICES_MENU_KEYS, PAYMENTS_MENU_KEYS, REQUESTS_MENU_KEYS, SIDE_NAV_KEYS,
  TRANSFERS_MENU_KEYS, HEADER_KEYS, ACCOUNTS_MENU_KEYS, REQUEST_CHEQUE_KEYS, BENEFICIARY_DOWNLOAD_KEYS,
  DOWNLOAD_CENTER_KEYS, SUPPORT_CENTER_KEYS, LAYOUT_DESC_MENU_ICONS_KEYS, REQUEST_DEBIT_CARD_KEYS, MENU_NAMES_ICONS_KEYS, BLOCK_CARD_KEYS
} from '../../utils/translation-constants'

export const userAccessLink = {
  ACCOUNTS: '/accounts',
  BILLPAYMENT: '/payments',
  INSTANTFT: '/quickPay',
  REQUESTS: '/requests',
  PENDING: '/approvals',
  COMPLETED: '/history',
  BENE: '/transfers',
}

export const titleDesc = {
  ACCOUNTS: SIDE_NAV_KEYS.ACCOUNTS,
  BILLPAYMENT: SIDE_NAV_KEYS.PAYMENTS,
  //INSTANTFT: 'Quick Pay',
  REQUESTS: SIDE_NAV_KEYS.REQUESTS,
  PENDING: SIDE_NAV_KEYS.APPROVALS,
  COMPLETED: SIDE_NAV_KEYS.HISTORY,
  BENE: SIDE_NAV_KEYS.TRANSFERS,
}
export const roleDisplayNames = {
  BENE: SIDE_NAV_KEYS.TRANSFERS,
  ACCOUNTS: SIDE_NAV_KEYS.ACCOUNTS,
  BILLPAYMENT: SIDE_NAV_KEYS.PAYMENTS,
  REQUESTS: SIDE_NAV_KEYS.REQUESTS,
  //INSTANTFT: 'Quick Pay',
  PENDING: SIDE_NAV_KEYS.APPROVALS,
  COMPLETED: SIDE_NAV_KEYS.HISTORY,
}

export const roleDisplayIcons = {
  BENE: Side_TransfersIcon,
  ACCOUNTS: Side_AccountsIcon,
  BILLPAYMENT: Side_PaymentsIcon,
  REQUESTS: Side_RequestIcon,
  INSTANTFT: Side_LoansIcon,
  PENDING: Side_Approval,
  COMPLETED: Side_History,
}

export const roleDisplayDashboardIcons = {
  BENE: Dash_TransfersIcon,
  ACCOUNTS: Dash_AccountsIcon,
  BILLPAYMENT: Dash_PaymentsIcon,
  REQUESTS: Dash_RequestIcon,
  INSTANTFT: Dash_DepositIcon,
  PENDING: Dash_ApprovalIcon,
  COMPLETED: Dash_HistoryIcon,
}

export const HEADER_MENUS = [
  {
    title: HEADER_KEYS.NOTIFICATION,
    desc: HEADER_KEYS.NOTIFICATION_DESCRIPTION,
    icon: Desc_AdditionalIcon,
    key: 'NOTIFICATION',
    link: '/notifications',
  },

  {
    title: HEADER_KEYS.PROFILE,
    desc: HEADER_KEYS.PROFILE_DESCRIPTION,
    icon: Desc_AdditionalIcon,
    key: 'PROFILE_SETTINGS',
    link: '/profile',
  },

  {
    title: HEADER_KEYS.CHANGE_PASSWORD,
    desc: HEADER_KEYS.CHANGE_PASSWORD_DESCRIPTION,
    icon: Desc_AdditionalIcon,
    key: 'CHANGE_PASSWORD',
    link: '/change-password',
  },
]

export const ACCOUNT_SUB_MENUS = [
  {
    title: ACCOUNTS_MENU_KEYS.STATEMENT,
    desc: ACCOUNTS_MENU_KEYS.STATEMENT_DESCRIPTION,
    icon: Account_StatementIcon,
    key: 'STATEMENTS',
    link: '/statement',
  },
  {
    title: ACCOUNTS_MENU_KEYS.PAYMENTS,
    desc: ACCOUNTS_MENU_KEYS.PAYMENTS_DESCRIPTION,
    icon: Account_PaymentIcon,
    key: 'PAYMENTS',
    link: '/payments',
  },
  {
    title: ACCOUNTS_MENU_KEYS.REQUESTS,
    desc: ACCOUNTS_MENU_KEYS.REQUESTS_DESCRIPTION,
    icon: Account_RequestIcon,
    key: 'REQUESTS',
    link: '/requests',
  },
  {
    title: ACCOUNTS_MENU_KEYS.BENEFICIARY_TRANSFERS,
    desc: ACCOUNTS_MENU_KEYS.BENEFICIARY_TRANSFERS_DESCRIPTION,
    icon: Account_Beneficiary_TransferIcon,
    key: 'BENEFICIARY_TRANSFER',
    link: '/transfers/beneficiary-transfers',
  },

  {
    title: ACCOUNTS_MENU_KEYS.DEPOSITS,
    desc: ACCOUNTS_MENU_KEYS.DEPOSITS_DESCRIPTION,
    icon: Account_Beneficiary_TransferIcon,
    key: 'DEPOSITS',
    link: '/deposit-view',
  },

  {
    title: ACCOUNTS_MENU_KEYS.LOANS,
    desc: ACCOUNTS_MENU_KEYS.LOANS_DESCRIPTION,
    icon: Account_Beneficiary_TransferIcon,
    key: 'LOANS',
    link: '/loans-view',
  },

  {
    title: ACCOUNTS_MENU_KEYS.SI,
    desc: ACCOUNTS_MENU_KEYS.SI_DESCRIPTION,
    icon: Account_Beneficiary_TransferIcon,
    key: 'SI',
    link: '/accounts/standing-instruction',
  },
  // {
  //   title: "Link Account",
  //   desc: "Description here",
  //   icon: Account_LinkIcon,
  //   key: "LINK_ACCOUNT",
  //   link: "/link-account",
  //   descIcon: Desc_LinkAccountIcon,
  // },
  // {
  //   title: "De Link Account",
  //   desc: "Description here",
  //   icon: Account_DelinkIcon,
  //   key: "DE_LINK_ACCOUNT",
  //   link: "/deLink-account",
  //   descIcon: Desc_DeLinkAccountIcon,
  // },
  {
    title: ACCOUNTS_MENU_KEYS.SET_ACCOUNT_NAME,
    desc: ACCOUNTS_MENU_KEYS.SET_ACCOUNT_NAME_DESCRIPTION,
    icon: Account_Set_account_nameIcon,
    key: 'SET_ACCOUNT_NAME',
    link: '/add-accountName',
  },
]

export const DASHBOARD_CONST_MENUS = [
  {
    title: SIDE_NAV_KEYS.DASHBOARD,
    desc: SIDE_NAV_KEYS.DASHBOARD_DESCRIPTION,
    icon: Side_DashboardIcon,
    key: 'DASHBOARD',
    link: '/dashboard',
  },
  {
    title: SIDE_NAV_KEYS.PORTFOLIO,
    desc: SIDE_NAV_KEYS.PORTFOLIO_DESCRIPTION,
    icon: Side_PortfolioIcon,
    key: 'PORTFOLIO',
    link: '/portfolio',
    dashIcon: Dash_PortfolioIcon,
  },
]

export const OTHER_MENUS = [
  {
    title: SIDE_NAV_KEYS.EXCHANGE_RATES,
    desc: SIDE_NAV_KEYS.EXCHANGE_RATES_DESCRIPTION,
    icon: Side_QuickLinksIcon,
    key: 'EXCHANGE_RATES',
    link: '/exchange-rate',
    dashIcon: Q_ExchangeIcon,
  },
  {
    title: SIDE_NAV_KEYS.OTHER_SERVICES,
    desc: SIDE_NAV_KEYS.OTHER_SERVICES_DESCRIPTION,
    icon: Side_OtherServices,
    key: 'OTHER_SERVICES',
    link: '/additional-links',
    dashIcon: OtherServicesIcon,
  },
]

export const OTHER_SUB_MENUS = [
  {
    title: OTHER_SRVICES_MENU_KEYS.DOWNLOAD_CENTER,
    desc: OTHER_SRVICES_MENU_KEYS.DOWNLOAD_CENTER_DESC,
    icon: Other_DownloadCenterIcon,
    key: 'DOWNLOAD_CENTER',
    link: '/download-center',
  },

  {
    title: OTHER_SRVICES_MENU_KEYS.SUPPORT_CENTER,
    desc: OTHER_SRVICES_MENU_KEYS.SUPPORT_CENTER_DESC,
    icon: Other_SupportCenterIcon,
    key: 'SUPPORT_CENTER',
    link: '/support-center',
  },

  // {
  //   title: 'Calculator',
  //   desc: 'Calculate the EMI for Loans, Interest for Deposits here.',
  //   icon: Q_CalculatorIcon,
  //   key: 'CALCULATOR',
  //   link: '/calculator',
  // },

  {
    title: OTHER_SRVICES_MENU_KEYS.TERMS_CONDITIONS,
    desc: OTHER_SRVICES_MENU_KEYS.TERMS_CONDITIONS_DESC,
    icon: Q_TCIcon,
    key: 'TERMS_AND_CONDITIONS',
    link: '/tc',
  },
]

export const PAYMENTS_MENUS = [
  {
    title: PAYMENTS_MENU_KEYS.PAY_BILL,
    desc: PAYMENTS_MENU_KEYS.PAY_BILL_DESCRIPTION,
    icon: Dash_PaymentsIcon,
    key: 'PAY_BILLS',
    link: '/payments/payBills', 
    children:[]
  },
  {
    title: PAYMENTS_MENU_KEYS.ADD_BILLER,
    desc: PAYMENTS_MENU_KEYS.ADD_BILLER_DESCRIPTION,
    icon: P_AddBillerIcon,
    key: 'ADD_BILLER',
    link: '/payments/add-biller', // '/payments/top-ups',
  },
  {
    title: PAYMENTS_MENU_KEYS.VIEW_BILLER,
    desc: PAYMENTS_MENU_KEYS.VIEW_BILLER_DESCRIPTION,
    icon: P_ViewBillerIcon,
    key: 'VIEW_BILLER',
    link: '/payments/biller-list', // '/payments/top-ups',
  },

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_SCHEDULED_PAYMENTS,
    desc: PAYMENTS_MENU_KEYS.VIEW_SCHEDULED_PAYMENTS_DESCRIPTION,
    icon: P_ViewScheduledIcon,
    key: 'SCHEDULED_PAYMENTS',
    link: '/payments/viewScheduled',
  },
  // {
  //   title: PAYMENTS_MENU_KEYS.SERVICES,
  //   desc: PAYMENTS_MENU_KEYS.SERVICES_DESCRIPTION,
  //   icon: P_ServicesIcon,
  //   key: 'PRODUCT',
  //   link: '/payments/products/list',
  // },
  // {
  //   title: PAYMENTS_MENU_KEYS.BUY_DATA,
  //   desc: PAYMENTS_MENU_KEYS.BUY_DATA_DESCRIPTION,
  //   icon: P_BuyDataIcon,
  //   key: 'BUY_DATA',
  //   link: '/payments/buyData/list',
  // },
  // {
  //   title: PAYMENTS_MENU_KEYS.BUY_AIRTIME,
  //   desc: PAYMENTS_MENU_KEYS.BUY_AIRTIME_DESCRIPTION,
  //   icon: P_AirtimeIcon,
  //   key: 'BUY_AIRTIME',
  //   link: '/payments/top-ups/list',
  // },
]

export const PAYMENT_SERVICE_MENUS = [
  {
    title: 'School Payments',
    desc: 'Description here',
    icon: P_SchoolPaymentIcon,
    key: 'SCHOOL_PAYMENT',
    link: '/schoolPayments',
  },
  {
    title: 'Other Payments',
    desc: 'Description here',
    icon: P_OtherPaymentIcon,
    key: 'OTHER_PAYMENT',
    link: '/otherPayments',
  },
]

export const REQUEST_MENUS = [
  {
    title: REQUESTS_MENU_KEYS.CHEQUE,
    desc: REQUESTS_MENU_KEYS.CHEQUE_DESCRIPTION,
    icon: R_ChequeIcon,
    key: 'CHEQUE',
    link: '/requests/cheque',
  },
  {
    title: REQUESTS_MENU_KEYS.SI,
    desc: REQUESTS_MENU_KEYS.SI_DESCRIPTION,
    icon: R_SIIcon,
    key: 'SI',
    link: '/requests/standing-instruction',
  },
  {
    title: REQUESTS_MENU_KEYS.DEBIT_CARD,
    desc: REQUESTS_MENU_KEYS.DEBIT_CARD_DESCRIPTION,
    icon: R_Debit_card,
    key: 'DEBIT_CARD',
    link: '/requests/debit-card',
  },
]


export const REQUEST_CHEQUE_MENUS = [
  {
    title: REQUEST_CHEQUE_KEYS.CHEQUE_BOOK,
    desc: REQUEST_CHEQUE_KEYS.CHEQUE_BOOK_DESCRIPTION,
    icon: R_ChequeBookIcon,
    key: 'CHEQUE_BOOK',
    link: '/requests/cheque/cheque-book-request',
  },
  {
    title: REQUEST_CHEQUE_KEYS.STOP_CHEQUE,
    desc: REQUEST_CHEQUE_KEYS.STOP_CHEQUE_DESCRIPTION,
    icon: R_ChequeStopIcon,
    key: 'STOP_CHEQUE',
    link: '/requests/cheque/stop-cheque-payment',
  },
  {
    title: REQUEST_CHEQUE_KEYS.CHEQUE_STATUS,
    desc: REQUEST_CHEQUE_KEYS.CHEQUE_STATUS_DESC,
    icon: R_Cheque_Status_Icon,
    key: 'CHEQUE_STATUS',
    link: '/requests/cheque/cheque-status',
  },
  // {
  //   title: "Cheque Status",
  //   desc: "Description here",
  //   icon: R_ChequeStatusIcon,
  //   key: "CHEQUE_STATUS",
  //   link: "/requests/cheque/cheque-status",
  // },
]

export const REQUEST_DEBIT_CARD_MENUS = [
  {

    title: REQUEST_DEBIT_CARD_KEYS.CARD_REQUEST,
    desc: REQUEST_DEBIT_CARD_KEYS.CARD_REQUEST_DESCRIPTION,
    icon: Request_Debit_card,
    key: 'DEBIT_CARD_REQUEST',
    link: '/requests/debit-card/card-request',
  },

  {

    title: BLOCK_CARD_KEYS.BLOCK_CARD,
    desc: BLOCK_CARD_KEYS.BLOCK_CARD_DESCRIPTION,
    icon: Block_Debit_card,
    key: 'DEBIT_CARD_BLOCK',
    link: '/requests/debit-card/block-card',
  },

  // {
  //   title: 'Change Card Pin',
  //   desc: 'Description here',
  //   icon: DashboardIcon,
  //   key: 'CHANGE_CARD_PIN',
  //   link: '/requests/debit-card/change-card-pin',
  // },
  // {
  //   title: 'Card Load',
  //   desc: 'Description here',
  //   icon: DashboardIcon,
  //   key: 'CARD_LOAD',
  //   link: '/requests/debit-card/card-load',
  // },
  // {
  //   title: 'Block Debit Card',
  //   desc: 'Description here',
  //   icon: DashboardIcon,
  //   key: 'BLOCK_DEBIT_CARD',
  //   link: '/requests/debit-card/block-debit-card',
  // },
]

export const REQUEST_SI_MENUS = [
  {
    title: 'Create SI',
    desc: 'Description here',
    icon: R_SIIcon,
    key: 'CHANGE_CARD_PIN',
    link: '/requests/standing-instruction/create',
  },
  {
    title: 'SI View',
    desc: 'Description here',
    icon: R_SIIcon,
    key: 'CARD_LOAD',
    link: '/requests/standing-instruction/view',
  },
]

export const TRANSFER_MENUS = [
  {
    title: TRANSFERS_MENU_KEYS.ADD_BENEFICIARY,
    desc: TRANSFERS_MENU_KEYS.ADD_BENEFICIARY_DESCRIPTION,
    icon: Transfers_AddIcon,
    key: 'ADD',
    link: '/transfers/add-beneficiary',
  },

  {
    title: TRANSFERS_MENU_KEYS.BENEFICIARY_TRANSFERS,
    desc: TRANSFERS_MENU_KEYS.BENEFICIARY_TRANSFERS_DESCRIPTION,
    icon: Transfers_MakeTransferIcon,
    key: 'MAKE_TRANSFER',
    link: '/transfers/beneficiary-transfers',
  },
  {
    title: TRANSFERS_MENU_KEYS.VIEW_BENEFICIARY,
    desc: TRANSFERS_MENU_KEYS.VIEW_BENEFICIARY_DESCRIPTION,
    icon: Transfers_ViewBeneficiariesIcon,
    key: 'VIEW_BENEFICIARIES',
    link: '/transfers/beneficiary-view',
  },
  {
    title: TRANSFERS_MENU_KEYS.SALARY_UPLOAD,
    desc: TRANSFERS_MENU_KEYS.SALARY_UPLOAD_DESCRIPTION,
    icon: Transfers_Salary_UploadIcon,
    key: 'SALARY_UPLOAD',
    link: '/transfers/salaryUpload', //'/transfers/download-receipts'
  },

  {
    title: TRANSFERS_MENU_KEYS.BULK_TRANSFER,
    desc: TRANSFERS_MENU_KEYS.BULK_TRANSFER_DESCRIPTION,
    icon: Transfers_BulTransferIcon,
    key: 'BULK_TRANSFER',
    link: '/transfers/bulkTransfer', //'/transfers/download-receipts'
  },

  {
    title: TRANSFERS_MENU_KEYS.QUICK_PAY,
    desc: TRANSFERS_MENU_KEYS.QUICK_PAY_DESCRIPTION,
    icon: Account_Quick_TransferIcon,
    key: 'QUICK_TRANSFER',
    link: '/transfers/quick-pay',
  },

  // {
  //   title: TRANSFERS_MENU_KEYS.DOWNLOAD_CENTER,
  //   desc: TRANSFERS_MENU_KEYS.DOWNLOAD_CENTER_DESCRIPTION,
  //   icon: Other_DownloadCenterIcon,
  //   key: 'DOWNLOAD_CENTER',
  //   link: '/transfers/download-center',
  // },
  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_SCHEDULED_TRANSFERS,
    desc: TRANSFERS_MENU_KEYS.VIEW_SCHEDULED_TRANSFERS_DESCRIPTION,
    icon: Transfers_ViewScheduledIcon,
    key: 'SCHEDULED_TRANSFERS',
    link: '/transfers/viewScheduled',
  },
  // {
  //   title: 'Download Receipts',
  //   desc: 'Download your Receipts',
  //   icon: D_ReceiptsIcon,
  //   key: 'TRANSFERS_RECEIPTS',
  //   link: '/transfers/receipts',
  // },
]

export const BENEFICIARY_OPTION_MENUS = [
  {
    title: ADD_BENEFICIARY_KEYS.INTERNAL_BENEFICIARY,
    desc: "",
    icon: Transfers_InternalIcon,
    key: 'INTERNAL_BENE',
    link: '/transfers/add-beneficiary/internal',
  },
  {
    title: ADD_BENEFICIARY_KEYS.DOMESTIC_BENEFICIARY,
    desc: "",
    icon: Transfers_DomesticIcon,
    key: 'DOMESTIC_BENE',
    link: '/transfers/add-beneficiary/domestic',
  },
  {
    title: ADD_BENEFICIARY_KEYS.INTERNATIONAL_BENEFICIARY,
    desc: "",
    icon: Transfers_InternationalIcon,
    key: 'INTERNATIONAL_BENE',
    link: '/transfers/add-beneficiary/international',
  },
  {
    title: ADD_BENEFICIARY_KEYS.REGIONAL_BENEFICIRAY,
    desc: "",
    icon: Transfers_RegionalIcon,
    key: 'REGIONAL_BENE',
    link: '/transfers/add-beneficiary/regional',
  },
]

export const BENEFICIARY_DOWNLOAD_MENUS = [
  {
    title: BENEFICIARY_DOWNLOAD_KEYS.DOWNLOAD_RECEIPT,
    desc: '',
    icon: D_ReceiptsIcon,
    key: 'RECEIPTS',
    link: '/transfers/download-center/reciept',
  },
  {
    title: BENEFICIARY_DOWNLOAD_KEYS.BI_STATEMENT,
    desc: '',
    icon: D_BIIcon,
    key: 'BI_STATEMENT',
    link: '/transfers/download-center/bi',
  },
  {
    title: BENEFICIARY_DOWNLOAD_KEYS.INTERNATIONAL_REMITTANCE_RECEIPT,
    desc: '',
    icon: D_MTIcon,
    key: 'MT103',
    link: '/transfers/download-center/mt103',
  },
  {
    title: BENEFICIARY_DOWNLOAD_KEYS.SALARY_FILE_STATUS,
    desc: '',
    icon: Transfers_Salary_UploadIcon,
    key: 'SALARY_STATUS_TRANSFER_DOWNLOAD',
    link: '/transfers/download-center/salary-file-status-download',
  }
]

export const DOWNLOAD_CENTER_MENUS = [
  {
    title: DOWNLOAD_CENTER_KEYS.DOWNLOAD_RECEIPT,
    desc: '',
    icon: D_ReceiptsIcon,
    key: 'RECEIPTS',
    link: '/receipts',
  },
  {
    title: DOWNLOAD_CENTER_KEYS.BI_STATEMENT,
    desc: '',
    icon: D_BIIcon,
    key: 'BI_STATEMENT',
    link: '/biStatement',
  },
  {
    title: DOWNLOAD_CENTER_KEYS.INTERNATIONAL_REMITTANCE_RECEIPT,
    desc: '',
    icon: D_MTIcon,
    key: 'MT103',
    link: '/mt103',
  },
  {
    title: DOWNLOAD_CENTER_KEYS.SALARY_FILE_STATUS,
    desc: '',
    icon: Transfers_Salary_UploadIcon,
    key: 'SALARY_STATUS_DOWNLOAD',
    link: '/salary-file-status-download',
  },
  // {
  //   title: DOWNLOAD_CENTER_KEYS.VIEW_SCHEDULED_PAYMENT,
  //   desc: '',
  //   icon: Transfers_QuickTransferIcon,
  //   key: 'SCHEDULED_PAYMENT',
  //   link: '/transfers/download-center/viewScheduled',
  // },
]

export const SUPPORT_CENTER_MENUS = [
  {
    title: SUPPORT_CENTER_KEYS.LOCATE_US,
    desc: SUPPORT_CENTER_KEYS.LOCATE_US_DESCRIPTION,
    icon: S_BranchIcon,
    key: 'LOCATE_US',
    link: '/locateUs',
  },
  {
    title: SUPPORT_CENTER_KEYS.FAQ,
    desc: SUPPORT_CENTER_KEYS.FAQ_DESCRIPTION,
    icon: S_FAQIcon,
    key: 'FAQ',
    link: '/faq',
  },

  {
    title: SUPPORT_CENTER_KEYS.SUGGESTIONS,
    desc: SUPPORT_CENTER_KEYS.SUGGESTIONS_DESCRIPTION,
    icon: S_SuggestionIcon,
    key: 'SUGGESTIONS',
    link: '/suggestion',
  },

  {
    title: SUPPORT_CENTER_KEYS.CONTACT_US,
    desc: SUPPORT_CENTER_KEYS.CONTACT_US_DESCRIPTION,
    icon: S_ContactIcon,
    key: 'CONTACT_US',
    link: '/contact-us',
  },

  {
    title: SUPPORT_CENTER_KEYS.ABOUT_US,
    desc: SUPPORT_CENTER_KEYS.ABOUT_US_DESCRIPTION,
    icon: S_AboutIcon,
    key: 'ABOUT_US',
    link: '/about-us',
  },
]

export const LAYOUT_DESC_MENU_ICONS = [
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.LINK_ACCOUNT,
    key: 'LINK_ACCOUNT',
    descIcon: Desc_LinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.DE_LINK_ACCOUNT,
    key: 'DE_LINK_ACCOUNT',
    descIcon: Desc_DeLinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SET_ACCOUNT_NAME,
    key: 'SET_ACCOUNT_NAME',
    descIcon: Desc_DeLinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.DOWNLOAD_CENTER,
    key: 'DOWNLOAD_CENTER',
    descIcon: Desc_DownloadIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.APPROVALS,
    key: 'APPROVAL',
    descIcon: Desc_DownloadIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.HISTORY,
    key: 'HISTORY',
    descIcon: Desc_DownloadIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SALARY_UPLOAD,
    key: 'SALARY_UPLOAD',
    descIcon: Desc_DownloadIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.NOTIFICATION,
    key: 'NOTIFICATION',
    descIcon: Desc_AdditionalIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.PROFILE_SETTING,
    key: 'PROFILE_SETTINGS',
    descIcon: Desc_AdditionalIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.CHANGE_PASSWORD,
    key: 'CHANGE_PASSWORD',
    descIcon: Desc_AdditionalIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.ADDITIONAL_LINK,
    key: 'ADDITIONAL_LINKS',
    descIcon: Desc_AdditionalIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SUPPORT_CENTER,
    key: 'SUPPORT_CENTER',
    descIcon: Desc_SupportIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.LOANS,
    key: 'LOAN',
    descIcon: Desc_LoanIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SI,
    key: 'SI',
    descIcon: Desc_LoanIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.DEPOSITS,
    key: 'DEPOSIT',
    descIcon: Desc_depositeIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.RECEIPTS,
    icon: DashboardIcon,
    key: 'RECEIPTS',
    descIcon: Desc_DeLinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SALARY_FILE_STATUS,
    key: 'SALARY_STATUS_DOWNLOAD',
    descIcon: Desc_DownloadIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.BI_STATEMENT,
    icon: DashboardIcon,
    key: 'BI_STATEMENT',
    descIcon: Desc_DeLinkAccountIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.MT103,
    icon: DashboardIcon,
    key: 'MT103',
    descIcon: Desc_Mt103,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.LOCATE_US,
    icon: DashboardIcon,
    key: 'LOCATE_US',
    descIcon: Desc_BranchIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.DEPOSIT,
    icon: DashboardIcon,
    key: 'DEPOSIT',
    descIcon: Desc_DepositIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.FAQ,
    icon: DashboardIcon,
    key: 'FAQ',
    descIcon: Desc_FAQIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SUGGESTIONS,
    icon: DashboardIcon,
    key: 'SUGGESTIONS',
    descIcon: Desc_SuggestionsIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.CALCULATOR,
    icon: DashboardIcon,
    key: 'CALCULATOR',
    descIcon: Desc_CalculatorIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.EXCHANGE_RATE,
    icon: DashboardIcon,
    key: 'EXCHANGE_RATES',
    descIcon: Desc_ExchangeRatesIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.TERMS_CONDITIONS,
    icon: DashboardIcon,
    key: 'TERMS_AND_CONDITIONS',
    descIcon: Desc_SuggestionsIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SCHOOL_PAYMENT,
    icon: DashboardIcon,
    key: 'SCHOOL_PAYMENT',
    descIcon: Desc_DeLinkAccountIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.ADD_BILLER,
    icon: DashboardIcon,
    key: 'ADD_BILLER',
    descIcon: Desc_DeLinkAccountIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.VIEW_BILLER,
    icon: DashboardIcon,
    key: 'VIEW_BILLER',
    descIcon: Desc_DeLinkAccountIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.OTHER_PAYMENTS,
    icon: DashboardIcon,
    key: 'OTHER_PAYMENT',
    descIcon: Desc_DeLinkAccountIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.CONTACT_US,
    icon: S_ContactIcon,
    key: 'CONTACT_US',
    descIcon: Desc_Contact_UsIcon,
  },

  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.ABOUT_US,
    icon: S_ContactIcon,
    key: 'ABOUT_US',
    descIcon: Desc_Contact_UsIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.OTHER_SERVICES,
    key: 'OTHER_SERVICES',
    descIcon: Desc_SupportIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SCHEDULED_TRANSFERS,
    icon: DashboardIcon,
    key: 'SCHEDULED_TRANSFERS',
    descIcon: Desc_DeLinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.SCHEDULED_PAYMENTS,
    icon: DashboardIcon,
    key: 'SCHEDULED_PAYMENTS',
    descIcon: Desc_DeLinkAccountIcon,
  },
  {
    desc: LAYOUT_DESC_MENU_ICONS_KEYS.DEBIT_CARD_REQUEST,
    icon: DashboardIcon,
    key: 'DEBIT_CARD_REQUEST',
    descIcon: Desc_DebitCardIcon,
  },
]
